export default __webpack_public_path__ + "static/media/mail.eb5b6f2f.svg";